export default __webpack_public_path__ + "static/media/6A.b5064bab.jpg";